// extracted by mini-css-extract-plugin
export default {"alertsWrapper":"AlertPopup_alertsWrapper__aSZSd","popupTitle":"AlertPopup_popupTitle__a3yap"};